export default __webpack_public_path__ + "static/media/dot_green.dc55b2f3.jpg";